import { render, staticRenderFns } from "./SpecialFeatures.vue?vue&type=template&id=5911d8c2&scoped=true&"
import script from "./SpecialFeatures.vue?vue&type=script&lang=js&"
export * from "./SpecialFeatures.vue?vue&type=script&lang=js&"
import style0 from "./SpecialFeatures.vue?vue&type=style&index=0&id=5911d8c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5911d8c2",
  null
  
)

export default component.exports